/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_DisconnectInputs */



/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Connections_DisconnectInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect = /** @type {((inputs?: Connections_DisconnectInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_DisconnectInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ontkoppelen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déconnecter")
	return /** @type {LocalizedString} */ ("Disconnect")
});